import { bundleConfig } from '../../../../config';
import { http } from '../../../../api/axios';
import { BundleCategoryResponse } from '../bundleCategories';

export interface CategoryParamTypes {
    loanFormat: string;
    ageCategory: string;
}

export function fetchBundleCategories({ loanFormat, ageCategory }: CategoryParamTypes) {
    const endpoint = bundleConfig().endpointForeignLanguageBundles;

    const pathParams = {
        loanFormat: loanFormat === 'all' ? null : loanFormat,
        kind: 'categories'
    };

    const params = {
        ageCategory: ageCategory === 'All+Ages' ? null : ageCategory
    };

    return http.get<BundleCategoryResponse>(endpoint, { params, pathParams }).then(response => response.data);
}
